import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { AML_LEVEL_ADVANCE } from 'apps/auth/constants/Constants';
import { ISRAEL, USA } from 'apps/auth/constants/WellKnownCountries';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

import DefaultLimits from './DefaultLimits';
import IsraelLimits from './IsraelLimits';
import UsaLimits from './UsaLimits';
import IncreaseLimitButton from '../gaLimits/IncreaseLimitButton';

const IndividualLimits = ({ title, lang, country }) => {
    const {
        profile_form: profileForm,
        hideIncreaseLimitButton,
        ofakimInProgress,
        show_modal_profile_update_block,
        show_modal_terms_update_block,
        redirectUrl,
        backUrl,
        limits,
        tffLimit,
        locked,
        alarmLimits,
        show_modal_kyc_increase_limit,
        ofakimFlowUpdateProfile,
        ofakimHandleKycFlow,
    } = useExtra();
    const messages = usePageMessages();
    const { countryId } = useAuth();
    const hasNewUsaLimits = countryId === USA && UsaService.isNewLimits(profileForm);
    const hasIsraelLimits = countryId === ISRAEL;

    useEffect(() => {
        if (countryId === USA && (profileForm || limits)) {
            amplitude.getInstance().logEvent('Limits Screen Shown');
        }
    }, []);
    const button = (
        <Row indent="adaptive-16-24">
            <IncreaseLimitButton />
        </Row>
    );

    let component = (
        <DefaultLimits
            title={title}
            progressWidth={limits.usedPercent}
            isExhaustedLimit={alarmLimits < limits.usedPercent}
            currency={toLowerCase(limits.currencyCode)}
            spendSum={getLocalizedRawAmount(lang, country, limits.used)}
            spendText={messages.spent}
            leftSum={getLocalizedRawAmount(lang, country, limits.max - limits.used)}
            leftText={limits.totalLimitEnd ? messages.profileLimitExpires : null}
            isLimitError={limits.max === 0}
            limitErrorText={messages.profileLimitFrodError}
            isShowLimitsButton={profileForm.upgradable && limits.aml}
            button={button}
        />
    );
    if (hasNewUsaLimits) {
        component = (
            <UsaLimits
                title={messages.headerTitle}
                limits={profileForm.limitsGroup}
                spendText={messages.spent}
                leftText={messages.left}
                limitErrorText={messages.profileLimitFrodError}
                until={messages.until}
                isShowLimitsButton={profileForm.amlLimit.currentLimit < AML_LEVEL_ADVANCE}
                button={button}
                lang={lang}
                country={country}
            />
        );
    }
    return (
        <>
            {component}
            {hasIsraelLimits && (
                <IsraelLimits
                    limits={limits}
                    ofakimHandleKycFlow={ofakimHandleKycFlow}
                    tffLimit={tffLimit}
                    ofakimGtLimits={messages.ofakimGtLimits}
                    ofakimInProgress={ofakimInProgress}
                    gtLimitLocked={messages.gtLimitLocked}
                    locked={locked}
                    leftText={messages.profileTffLimitExpires}
                    profileSpent={messages.profileSpent}
                    gaLimitsATMLimitResetLimitInfo={messages.gaLimitsATMLimitResetLimitInfo}
                    profileLimitFrodError={messages.profileLimitFrodError}
                    hideIncreaseLimitButton={hideIncreaseLimitButton}
                    alarmLimits={alarmLimits}
                    gaLimitProcessButton={messages.gaLimitProcessButton}
                    limitsReviewingDocument={messages.limitsReviewingDocument}
                    show_modal_profile_update_block={show_modal_profile_update_block}
                    show_modal_terms_update_block={show_modal_terms_update_block}
                    redirectUrl={redirectUrl}
                    backUrl={backUrl}
                    show_modal_kyc_increase_limit={show_modal_kyc_increase_limit}
                    ofakimFlowUpdateProfile={ofakimFlowUpdateProfile}
                />
            )}
        </>
    );
};
export default IndividualLimits;
